/**
 * Track vue-resource requests so a new Issues/Buy Box fetch can abort the previous one.
 * vue-resource Request exposes .abort() (XMLHttpRequest).
 */

export function createRequestGate () {
  var requests = []
  var generation = 0

  return {
    /** Bump generation and abort any in-flight requests from the previous generation. */
    begin: function () {
      generation += 1
      for (var i = 0; i < requests.length; i++) {
        try {
          if (requests[i] && typeof requests[i].abort === 'function') {
            requests[i].abort()
          }
        } catch (e) { /* already settled */ }
      }
      requests = []
      return generation
    },
    /** Current generation token — ignore responses when gen !== gate.generation(). */
    generation: function () {
      return generation
    },
    isCurrent: function (gen) {
      return gen === generation
    },
    /**
     * Wrap $http options so the Request is tracked and abortable.
     * @param {object} [opts]
     * @returns {object}
     */
    trackOpts: function (opts) {
      opts = opts ? Object.assign({}, opts) : {}
      var prevBefore = opts.before
      opts.before = function (request) {
        requests.push(request)
        if (typeof prevBefore === 'function') prevBefore(request)
      }
      return opts
    },
    clear: function () {
      requests = []
    }
  }
}

/** True when a rejection was caused by abort/cancel (ignore as error). */
export function isRequestAborted (err) {
  if (!err) return false
  if (err.status === 0 && (err.statusText === 'abort' || err.statusText === 'AbortError')) return true
  if (err.message && /abort/i.test(String(err.message))) return true
  return false
}



// WEBPACK FOOTER //
// ./src/utils/requestGate.js